import React from 'react'
import styled from 'styled-components'
import { Wrapper, H } from '@farewill/ui'
import {
  GTR,
  CONTAINER_PADDING_HORIZONTAL_AT_BP,
  CONTENT_OUTER_WIDTH,
} from '@farewill/ui/tokens'
import { screenMin } from '@farewill/ui/helpers/responsive'

import Story from './GiftStory'
import type { GiftStory } from './GiftStory/types'

const StyledFlexWrapper = styled(Wrapper)`
  display: flex;
  flex-direction: column;
  max-width: ${CONTENT_OUTER_WIDTH};
  margin: 0 auto;
  gap: ${GTR.L};

  ${screenMin.l`
    gap: ${GTR.XL};
  `}
`

const StyledH = styled(H)`
  text-wrap: balance;
`

const GiftStories = ({
  stories,
  title,
}: {
  stories: GiftStory[]
  title: React.ReactNode
}): React.ReactElement => (
  <Wrapper>
    <StyledH
      size="L"
      decorative
      container
      containerVerticalPadding={0}
      margin={[0, 0, 'L']}
      centeredFromL
      marginFromL={[0, 'auto', 'XXL']}
      maxWidthInColumns={9}
    >
      {title}
    </StyledH>

    <StyledFlexWrapper paddingFromL={[0, CONTAINER_PADDING_HORIZONTAL_AT_BP.L]}>
      {stories.map(
        (
          {
            title: storyTitle,
            description,
            source,
            image,
            imageTransformationParams,
            quoteWrap,
          },
          index
        ) => (
          <Story
            key={source}
            title={storyTitle}
            description={description}
            source={source}
            quoteWrap={quoteWrap}
            image={image}
            imageTransformationParams={imageTransformationParams}
            imageOnLeft={index % 2 !== 0}
          />
        )
      )}
    </StyledFlexWrapper>
  </Wrapper>
)

export default GiftStories
